<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de Territorios</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/sector+c" (click)="createTerritory()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncTerritory | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let territory">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/territory+u"
                    (click)="updateTerritory(territory)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a
                    appOnlysuperuser="/territory"
                    (click)="eliminate(territory)"
                    class="icon-button"
                  >
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="nit">
              <th mat-header-cell *matHeaderCellDef>NIT</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.nit }}
              </td>
            </ng-container>

            <ng-container matColumnDef="zone">
              <th mat-header-cell *matHeaderCellDef>Zona</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.zone }}
              </td>
            </ng-container>

            <ng-container matColumnDef="resolution">
              <th mat-header-cell *matHeaderCellDef>Resolución</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.resolution }}
              </td>
            </ng-container>

            <ng-container matColumnDef="legalRepresentation">
              <th mat-header-cell *matHeaderCellDef>Representación Legal</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.legalRepresentation }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lifePlan">
              <th mat-header-cell *matHeaderCellDef>Plan de vida</th>
              <td mat-cell *matCellDef="let territory">
                {{ territory.lifePlan?.name }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchTerritory($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
